import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Webshops } from '../../../store/models/webshops';

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    constructor(
        private restService: RestService,
    ) { }
    

    getReceiptlistAsync(belegart:string, archive:boolean): Observable<Webshops.IReceiptDto[]>{
            return this.restService.request<void, Webshops.IReceiptDto[]>({
            method: 'GET',
            url: '/api/app/webshop/receiptlist?belegart='+belegart+'&archive='+archive
        });
    }

}
